export const HOME_ROUTE = 'home';
export const HOME_TAB_ROUTE = 'home/:tab';
export const FAQ = 'faq';
export const News = 'news';
export const PRICES = 'prices';
export const SELL_ROUTE = 'sell';
export const PURCHASE_ROUTE = 'purchase';
export const TRANSACTIONS_ROUTE = 'transactions';
export const PENDING_TRANSACTIONS_ROUTE = 'pending-transactions';
export const UNAUTHORIZED_ROUTE = 'unauthorized';
export const SEJAM_ERROR_ROUTE = 'sejam-error';
export const NATIONAL_ID_ERROR_ROUTE = 'national-id-error';
export const CALCULATOR_ROUTE = 'calculator';
export const CALCULATOR_PROFIT_ROUTE = 'calculator-profit';
export const OTP_ROUTE = 'otp';
export const NATIONAL_ID_ROUTE = 'national-id';
export const SELL_DETAIL_ROUTE = 'sell-detail';
export const PROSPECTUS_ROUTE = 'prospectus';
export const RESULT_ROUTE = 'result';
export const SELL_OTP_ROUTE = 'sell-otp';
export const IPG_CALLBACK_ROUTE = 'ipg-callback';
export const PROVIDER_NOT_AVAILABLE_ROUTE = 'provider-not-available';
export const PROVIDER_CAPACITY_FULL_ROUTE = 'provider-capacity-full';
export const OFF_TIME_ERROR_ROUTE = 'offtime-error';
export const GENERAL_ERROR_ROUTE = 'error';
export const RECEIPT_ROUTE = 'receipt';
export const REGISTER_ROUTE = 'register';
export const LOGIN_ROUTE = 'login';
export const IPG_FAILED_ROUTE = 'ipg-failed';
export const FORGET_PASSWORD_ROUTE = 'forget-password';
export const FORGET_PASSWORD_NATIONAL_ID_ROUTE = 'forget-password-national-id';
export const FORGET_PASSWORD_OTP_ROUTE = 'forget-password-otp';
export const EXPIRED_NOTICE_ROUTE = 'expired-notice';
export const EXPIRED_PASSWORD_ROUTE = 'expire-password';
export const EXPIRED_SESSION_NOTICE_ROUTE = 'expire-session-notice';
export const PROFILE_ROUTE = 'profile';
export const SUPPORT_ROUTE = 'support';
export const CHANGE_PHONE_NUMBER_ROUTE = 'support';
export const USER_LOGIN_ACTIVITIES_ROUTE = 'logs';
export const INVESTMENT_LIST_ROUTE = 'investments';
export const USER_EXIST_WITH_ANOTHER_PHONE_NUMBER_ROUTE = 'exist-with-another-phone-number';
export const CREATE_PASSWORD_ROUTE = 'create-password';
export const SIGN_AGREEMENTS_ROUTE = 'sign-agreements';
export const SOON = 'soon';
export const PORTFO = 'portfo';
export const ALLPROFILES = 'allprofiles';
export const CASHOUT_ROUTE = 'cashout';
export const CASHIN_ROUTE = 'cashin';
export const CROWD_LIST_ROUTE = 'crowd-list';
export const SEJAM_CHECK_ROUTE = 'sejam-check';
export const SEJAM_NATIONAL_ID_ROUTE = 'sejam-national-id';
export const SEJAM_SUCCESS_ROUTE = 'sejam-successful';
export const IPO_ROUTE = 'ipo';
export const CHOICE_PAYMENT_METHOD_ROUTE = 'choice-payment-method';
export const PAYMENT_METHOD_CONDITIONS_ROUTE = 'payment-method-conditions';
export const SELL_STOCK_ROUTE = 'sell-stock';
export const TREASURE_HUNT_START_ROUTE = 'treasure-hunt-start';
export const TREASURE_HUNT_REGISTRATION_SUCCESSFUL_ROUTE = 'treasure-hunt-registration-successful';
export const TREASURE_HUNT_SUCCESSFUL_ROUTE = 'treasure-hunt-successful';
export const TREASURE_HUNT_NATIONAL_ID_ROUTE = 'treasure-hunt-national-id';
export const TREASURE_HUNT_CAPACITY_FULL_ROUTE = 'treasure-hunt-capacity-full';
export const CAMPAIGN_OTP_ROUTE = 'campaign-otp';
export const CAMPAIGN_AGREEMENT_ROUTE = 'campaign-agreement';
export const CAMPAIGN_SHAHKAR_ERROR_ROUTE = 'shahkar-error';
export const COLLATERAL_ROUTE = 'collateral';
export const CONFIRM_COLLATERAL_INFO_ROUTE = 'confirm-collateral-info';
export const COLLATERAL_WAITING_ROUTE = 'collateral-waiting';
export const COLLATERAL_REJECTED_ROUTE = 'collateral-rejected';
export const COLLATERAL_APPROVED_ROUTE = 'collateral-approved';
export const WALLETS_ROUTE = 'wallets';
export const WALLET_CASH_IN_ROUTE = 'wallet-cash-in';
export const WALLET_CASH_OUT_ROUTE = 'wallet-cash-out';
export const WALLET_TERMS_CONDITIONS_ROUTE = 'terms';
export const WALLET_IBAN_ROUTE = 'iban';
export const WALLET_BNPL_ROUTE = 'bnpl';
export const WALLET_BNPL_DETAIL_ROUTE = 'bnpl-detail';
export const WALLET_CASH_IN_INDISTINCTIVE_ROUTE = 'cash-in-indistinctive';
export const WALLET_CUTOFF_ROUTE = 'cutoff';
